import { render, staticRenderFns } from "./BulmaSnackbar.vue?vue&type=template&id=702013f5"
import script from "./BulmaSnackbar.vue?vue&type=script&lang=js"
export * from "./BulmaSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('702013f5')) {
      api.createRecord('702013f5', component.options)
    } else {
      api.reload('702013f5', component.options)
    }
    module.hot.accept("./BulmaSnackbar.vue?vue&type=template&id=702013f5", function () {
      api.rerender('702013f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaSnackbar/BulmaSnackbar.vue"
export default component.exports